<template>
<div>
  <masked-input
    class="form-control seconds-as-time"
    v-model="compTotalTimeEntered"
    mask="111:11"
    placeholder-char="0"
    placeholder="HHH:mm"
  />
</div>
</template>

<script>
import MaskedInput from "vue-masked-input";

export default {
  name: "InputSecondsAsTime",
  components: {
    MaskedInput,
  },
  mixins: [],
  props: {
    seconds: Number,
  },
  data() {
    return {
      totalTimeEntered: null,
      newSeconds: 0,
    };
  },
  mounted: function () {
    if (this.seconds) {
      this.totalTimeEntered = this.secondsToHHHmm(this.seconds, 3);
    }
  },
  computed: {
    compTotalTimeEntered: {
      get: function () {
        return this.totalTimeEntered;
      },
      set: function (value) {
        if (!value) return;
        this.totalTimeEntered = value;
        let newSeconds = this.timeToSeconds(value.replaceAll("_", "0"));
        // this.newSeconds = newSeconds;
        this.$emit("update:seconds", newSeconds);
      },
    },
  },
  methods: {
  },
  watch: {
    seconds(newValue, oldValue) {
      if (!newValue) return;
      if (!this.totalTimeEntered) {
        this.totalTimeEntered = this.secondsToHHHmm(newValue);
      } else if (
        this.totalTimeEntered.replace("0", "_") != newValue.toString().replace("0", "_")
      ) {
        this.totalTimeEntered = this.secondsToHHHmm(newValue);
      }
    },
  },
};
</script>
